import { BUDGET_INTERVAL } from 'constants/project';
import { DateTime } from 'luxon';
import type { BudgetRecurrence } from 'types/project';

const MONTH_FORMAT = 'LLLL yyyy';
const WEEK_FORMAT = "'week' W yyyy";

const dateFormat: {
  [key: string]: string;
} = {
  [BUDGET_INTERVAL.MONTH]: MONTH_FORMAT,
  [BUDGET_INTERVAL.WEEK]: WEEK_FORMAT,
};

const untilArchivedString = (date: DateTime, format: string) =>
  `From ${date.toFormat(format)} until archived`;

const endDateString = (startDate: DateTime, endDate: DateTime, format: string) =>
  `From ${startDate.toFormat(format)} - ${endDate.toFormat(format)}`;

export const makeBudgetPeriodLabel = (
  budgetRecurrence: BudgetRecurrence | undefined
): string | null | undefined => {
  if (!budgetRecurrence) {
    return null;
  }

  const startDateDt = DateTime.fromISO(budgetRecurrence.start_date!);
  const endDateDt = DateTime.fromISO(budgetRecurrence.end_date!);

  const chosenDateformat = dateFormat[budgetRecurrence.recur!];

  return !budgetRecurrence.end_date
    ? untilArchivedString(startDateDt, chosenDateformat)
    : endDateString(startDateDt, endDateDt, chosenDateformat);
};
